/**
 * Scripts
 */
import 'vite/modulepreload-polyfill'
import './js/lazysizes-config' // must precede lazysizes: config is read at its init
import "lazysizes"
import { startupTheme } from "./js/theme"

// Import modules
import './js/slider'
import './js/toggle'
import './js/projects'
import './js/projectGallery'
import './js/newsGallery'
import './js/loadMore'
import './js/teamDetails'
import './js/formGlyphs'
import './js/mapLink'
import './js/externalLinks'
import './js/prefetch'
import './js/heroPreload'
import './js/blockPreload'
import './js/preloadProjects'

// Import node modules
// import 'swiper/css'
// import 'swiper/css/navigation'
// import 'swiper/css/pagination'

import './sass/main.sass'

/**
 * Start Theme
 */
startupTheme()
